var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Content',{attrs:{"loginId":_vm.$route.params.loginId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }